import cardsModel from '@/mixins/cards-model';
import pagesModel from '@/mixins/pages-model';
import { mapState } from 'vuex';
import WarRoomService from '@/services/WarRoomService';
import sacTypeModel from '@/mixins/sac-type-model';

export default {
  mixins: [
    cardsModel,
    pagesModel,
    sacTypeModel,
  ],
  async created() {
    const channels = new Set();
    const pages = this.pagesFormatted.map((item) => {
      channels.add(item.channel);
      return item.value;
    });
    const channelsList = Array.from(channels);
    const sacTypeList = this.getTypesByChannels(channelsList);
    if (!this.card.props.filter) {
      this.card.props.filter = { sacFilter: { pages: { value: pages }, sac_type: { value: sacTypeList }, channels: { value: channelsList }, is_sac: true },
        listeningFilter: { channels: { value: channelsList }, is_sac: false } };
      this.card.props.sacFilterId = await this.generateFilterId({ pages: { value: pages }, channels: { value: channelsList },
        sac_type: { value: sacTypeList }, is_sac: true });
      this.card.props.listeningFilterId = await this.generateFilterId({ channels: { value: channelsList }, is_sac: false });
    }

    this.saveCards();
  },
  computed: {
    ...mapState('filter', [
      'accountId',
    ]),
  },
  methods: {
    async generateFilterId(filter) {
      return WarRoomService.encodeFilter({
        account_id: this.accountId,
        is_staging: this.isStaging,
        filter: JSON.stringify(filter),
      });
    },
    orderAggregatedData(orderData) {
      orderData.sort((listeningData, sacData) => {
        return sacData.z - listeningData.z;
      });
      return orderData;
    },
    aggregateResponses(responseListening, responseSac) {
      const response = {};

      const aggregatedData = responseListening.all.map(item => {
        const existsInResponseSac = responseSac.all.find(element => element.name === item.name);
        if (existsInResponseSac) {
          const aggregateObjects = this.aggregateProps(existsInResponseSac, item);
          return aggregateObjects;
        }
        return item;
      });

      const aggregateListeningWithSac = this.aggregateSacData(responseSac, [...aggregatedData]);

      response.all = this.orderAggregatedData(aggregateListeningWithSac);

      return response || [];
    },
    aggregateSacData(responseSac, aggregatedData) {
      for (let i = 0; i < responseSac.all.length; i++) {
        const existsInArray = aggregatedData.find(element => element.name === responseSac.all[i].name);
        if (!existsInArray) {
          aggregatedData.push(responseSac.all[i]);
        }
      }
      return aggregatedData;
    },
    aggregateProps(listeningObj, sacObj) {
      const aggregatedObj = {};

      for (const key in listeningObj) {
        if (listeningObj.hasOwnProperty(key) && sacObj.hasOwnProperty(key)) {
          aggregatedObj[key] = this.sumValues(listeningObj, sacObj, key);
        }
      }
      return aggregatedObj;
    },
    sumValues(listeningObj, sacObj, key) {
      return (typeof listeningObj[key] === 'number' && typeof sacObj[key] === 'number') ? listeningObj[key] + sacObj[key]
        : listeningObj[key] || sacObj[key];
    },
  },
};
